unit View.Boletos.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewBoletosEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbcliente_id: TLabel;
    edcliente_id: TDBEdit;
    lbconta_id: TLabel;
    edconta_id: TDBEdit;
    lbfuncionario_id: TLabel;
    edfuncionario_id: TDBEdit;
    lbstatus_titulo_id: TLabel;
    edstatus_titulo_id: TDBEdit;
    lbvalor: TLabel;
    edvalor: TDBEdit;
    lbdata_vencimento: TLabel;
    eddata_vencimento: TDBEdit;
    lbdata_processamento: TLabel;
    eddata_processamento: TDBEdit;
    lbnosso_numero: TLabel;
    ednosso_numero: TDBEdit;
    lbnosso_numero_dv: TLabel;
    ednosso_numero_dv: TDBEdit;
    lblinha_digitavel: TLabel;
    edlinha_digitavel: TDBEdit;
    lbcodigo_barras: TLabel;
    edcodigo_barras: TDBEdit;
    lbbanco_carteira_id: TLabel;
    edbanco_carteira_id: TDBEdit;
    lbdocumento: TLabel;
    eddocumento: TDBEdit;
    lbmensagem1: TLabel;
    edmensagem1: TDBEdit;
    lbmensagem2: TLabel;
    edmensagem2: TDBEdit;
    lbmensagem3: TLabel;
    edmensagem3: TDBEdit;
    lbtaxa_juros: TLabel;
    edtaxa_juros: TDBEdit;
    lbtaxa_multa: TLabel;
    edtaxa_multa: TDBEdit;
    lbarquivo_retorno: TLabel;
    edarquivo_retorno: TDBEdit;
    lbdata_retorno: TLabel;
    eddata_retorno: TDBEdit;
    lbdata_emissao: TLabel;
    eddata_emissao: TDBEdit;
    lbcodigo_carteira: TLabel;
    edcodigo_carteira: TDBEdit;
    lbparcela: TLabel;
    edparcela: TDBEdit;
    lbdata_pagamento: TLabel;
    eddata_pagamento: TDBEdit;
    lbvalor_pago: TLabel;
    edvalor_pago: TDBEdit;
    lbvalor_novo: TLabel;
    edvalor_novo: TDBEdit;
    lbdata_vencimento_nova: TLabel;
    eddata_vencimento_nova: TDBEdit;
    lbtipo_liquidacao_antecipada: TLabel;
    edtipo_liquidacao_antecipada: TDBEdit;
    lbid_boleto_digital: TLabel;
    edid_boleto_digital: TDBEdit;
    lbboleto_digital: TLabel;
    edboleto_digital: TDBEdit;
    lbid_externo: TLabel;
    edid_externo: TDBEdit;
    lbnumero_titulo_cliente: TLabel;
    ednumero_titulo_cliente: TDBEdit;
    lburl_boleto: TLabel;
    edurl_boleto: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientBoletosGet: TXDataWebClient;
    XDataClientBoletosDelete: TXDataWebClient;
    BoletosDataset: TXDataWebDataSet;
    BoletosDatasetid: TIntegerField;
    BoletosDatasetaliado_id: TIntegerField;
    BoletosDatasetdata_base_id: TIntegerField;
    BoletosDatasetcliente_id: TIntegerField;
    BoletosDatasetconta_id: TIntegerField;
    BoletosDatasetfuncionario_id: TIntegerField;
    BoletosDatasetstatus_titulo_id: TIntegerField;
    BoletosDatasetvalor: TFloatField;
    BoletosDatasetdata_vencimento: TDateTimeField;
    BoletosDatasetdata_processamento: TDateTimeField;
    BoletosDatasetnosso_numero: TStringField;
    BoletosDatasetnosso_numero_dv: TStringField;
    BoletosDatasetlinha_digitavel: TStringField;
    BoletosDatasetcodigo_barras: TStringField;
    BoletosDatasetbanco_carteira_id: TIntegerField;
    BoletosDatasetdocumento: TStringField;
    BoletosDatasetmensagem1: TStringField;
    BoletosDatasetmensagem2: TStringField;
    BoletosDatasetmensagem3: TStringField;
    BoletosDatasettaxa_juros: TFloatField;
    BoletosDatasettaxa_multa: TFloatField;
    BoletosDatasetarquivo_retorno: TStringField;
    BoletosDatasetdata_retorno: TDateTimeField;
    BoletosDatasetdata_emissao: TDateTimeField;
    BoletosDatasetcodigo_carteira: TIntegerField;
    BoletosDatasetparcela: TStringField;
    BoletosDatasetdata_pagamento: TDateTimeField;
    BoletosDatasetvalor_pago: TFloatField;
    BoletosDatasetvalor_novo: TFloatField;
    BoletosDatasetdata_vencimento_nova: TDateTimeField;
    BoletosDatasettipo_liquidacao_antecipada: TIntegerField;
    BoletosDatasetid_boleto_digital: TStringField;
    BoletosDatasetboleto_digital: TBooleanField;
    BoletosDatasetid_externo: TStringField;
    BoletosDatasetnumero_titulo_cliente: TStringField;
    BoletosDataseturl_boleto: TStringField;
    BoletosDatasetcodigo_interno: TIntegerField;
    BoletosDatasetexcluido: TBooleanField;
    BoletosDatasetinclusao: TDateTimeField;
    BoletosDatasetalteracao: TDateTimeField;
    BoletosDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientBoletosGetLoad(Response: TXDataClientResponse);
    procedure XDataClientBoletosDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientBoletosDeleteError(Error: TXDataClientError);
    procedure BoletosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewBoletosEdit: TFViewBoletosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewBoletosEdit }

procedure TFViewBoletosEdit.btSaveClick(Sender: TObject);
begin
  if BoletosDataset.State in dsEditModes then
  begin
        BoletosDataset.Post;
    BoletosDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewBoletosEdit.btDeleteClick(Sender: TObject);
begin
  if BoletosDataset.State in dsEditModes then
    BoletosDataset.Post;
  XDataClientBoletosDelete.Delete(BoletosDataset.EntitySetName,
    TJSObject(BoletosDataset.CurrentData));
end;


class function TFViewBoletosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewBoletosEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewBoletosEdit.InsertEntity;
begin
  BoletosDataset.Close;
  BoletosDataset.SetJsonData('{}');
  BoletosDataset.Open;
  BoletosDataset.Insert;
end;

class function TFViewBoletosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewBoletosEdit(AForm).FInserting := AInserting;
    TFViewBoletosEdit(AForm).FId := AId;
    TFViewBoletosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewBoletosEdit(AForm).InsertEntity
    else
      TFViewBoletosEdit(AForm).LoadEntity;
    TFViewBoletosEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewBoletosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewBoletosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    BoletosDataset.Connection.Model.DefaultSchema.FindEntityType(
      BoletosDataset.EntitySetName
    )
  );
  XDataClientBoletosGet.Get(BoletosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewBoletosEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewBoletosEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewBoletosEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewBoletosEdit.XDataClientBoletosGetLoad(Response: TXDataClientResponse);
begin
  BoletosDataset.Close;
  BoletosDataset.SetJsonData(Response.Result);
  BoletosDataset.Open;
  
  BoletosDataset.Edit;  
end;

procedure TFViewBoletosEdit.XDataClientBoletosDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewBoletosEdit.XDataClientBoletosDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewBoletosEdit.BoletosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewBoletosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewBoletosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.boletos.form.message');
  lbMessage := TLabel.Create('view.boletos.form.message.label');
  btCloseMessage := TButton.Create('view.boletos.form.message.button');
  btCancel := TButton.Create('view.boletos.form.btBack');
  btSave := TButton.Create('view.boletos.form.btSave');
  btDelete := TButton.Create('view.boletos.form.btDelete');
  lbid := TLabel.Create('view.boletos.form.lbid');
  edid := TDBEdit.Create('view.boletos.form.edid');
  lbaliado_id := TLabel.Create('view.boletos.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.boletos.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.boletos.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.boletos.form.eddata_base_id');
  lbcliente_id := TLabel.Create('view.boletos.form.lbcliente_id');
  edcliente_id := TDBEdit.Create('view.boletos.form.edcliente_id');
  lbconta_id := TLabel.Create('view.boletos.form.lbconta_id');
  edconta_id := TDBEdit.Create('view.boletos.form.edconta_id');
  lbfuncionario_id := TLabel.Create('view.boletos.form.lbfuncionario_id');
  edfuncionario_id := TDBEdit.Create('view.boletos.form.edfuncionario_id');
  lbstatus_titulo_id := TLabel.Create('view.boletos.form.lbstatus_titulo_id');
  edstatus_titulo_id := TDBEdit.Create('view.boletos.form.edstatus_titulo_id');
  lbvalor := TLabel.Create('view.boletos.form.lbvalor');
  edvalor := TDBEdit.Create('view.boletos.form.edvalor');
  lbdata_vencimento := TLabel.Create('view.boletos.form.lbdata_vencimento');
  eddata_vencimento := TDBEdit.Create('view.boletos.form.eddata_vencimento');
  lbdata_processamento := TLabel.Create('view.boletos.form.lbdata_processamento');
  eddata_processamento := TDBEdit.Create('view.boletos.form.eddata_processamento');
  lbnosso_numero := TLabel.Create('view.boletos.form.lbnosso_numero');
  ednosso_numero := TDBEdit.Create('view.boletos.form.ednosso_numero');
  lbnosso_numero_dv := TLabel.Create('view.boletos.form.lbnosso_numero_dv');
  ednosso_numero_dv := TDBEdit.Create('view.boletos.form.ednosso_numero_dv');
  lblinha_digitavel := TLabel.Create('view.boletos.form.lblinha_digitavel');
  edlinha_digitavel := TDBEdit.Create('view.boletos.form.edlinha_digitavel');
  lbcodigo_barras := TLabel.Create('view.boletos.form.lbcodigo_barras');
  edcodigo_barras := TDBEdit.Create('view.boletos.form.edcodigo_barras');
  lbbanco_carteira_id := TLabel.Create('view.boletos.form.lbbanco_carteira_id');
  edbanco_carteira_id := TDBEdit.Create('view.boletos.form.edbanco_carteira_id');
  lbdocumento := TLabel.Create('view.boletos.form.lbdocumento');
  eddocumento := TDBEdit.Create('view.boletos.form.eddocumento');
  lbmensagem1 := TLabel.Create('view.boletos.form.lbmensagem1');
  edmensagem1 := TDBEdit.Create('view.boletos.form.edmensagem1');
  lbmensagem2 := TLabel.Create('view.boletos.form.lbmensagem2');
  edmensagem2 := TDBEdit.Create('view.boletos.form.edmensagem2');
  lbmensagem3 := TLabel.Create('view.boletos.form.lbmensagem3');
  edmensagem3 := TDBEdit.Create('view.boletos.form.edmensagem3');
  lbtaxa_juros := TLabel.Create('view.boletos.form.lbtaxa_juros');
  edtaxa_juros := TDBEdit.Create('view.boletos.form.edtaxa_juros');
  lbtaxa_multa := TLabel.Create('view.boletos.form.lbtaxa_multa');
  edtaxa_multa := TDBEdit.Create('view.boletos.form.edtaxa_multa');
  lbarquivo_retorno := TLabel.Create('view.boletos.form.lbarquivo_retorno');
  edarquivo_retorno := TDBEdit.Create('view.boletos.form.edarquivo_retorno');
  lbdata_retorno := TLabel.Create('view.boletos.form.lbdata_retorno');
  eddata_retorno := TDBEdit.Create('view.boletos.form.eddata_retorno');
  lbdata_emissao := TLabel.Create('view.boletos.form.lbdata_emissao');
  eddata_emissao := TDBEdit.Create('view.boletos.form.eddata_emissao');
  lbcodigo_carteira := TLabel.Create('view.boletos.form.lbcodigo_carteira');
  edcodigo_carteira := TDBEdit.Create('view.boletos.form.edcodigo_carteira');
  lbparcela := TLabel.Create('view.boletos.form.lbparcela');
  edparcela := TDBEdit.Create('view.boletos.form.edparcela');
  lbdata_pagamento := TLabel.Create('view.boletos.form.lbdata_pagamento');
  eddata_pagamento := TDBEdit.Create('view.boletos.form.eddata_pagamento');
  lbvalor_pago := TLabel.Create('view.boletos.form.lbvalor_pago');
  edvalor_pago := TDBEdit.Create('view.boletos.form.edvalor_pago');
  lbvalor_novo := TLabel.Create('view.boletos.form.lbvalor_novo');
  edvalor_novo := TDBEdit.Create('view.boletos.form.edvalor_novo');
  lbdata_vencimento_nova := TLabel.Create('view.boletos.form.lbdata_vencimento_nova');
  eddata_vencimento_nova := TDBEdit.Create('view.boletos.form.eddata_vencimento_nova');
  lbtipo_liquidacao_antecipada := TLabel.Create('view.boletos.form.lbtipo_liquidacao_antecipada');
  edtipo_liquidacao_antecipada := TDBEdit.Create('view.boletos.form.edtipo_liquidacao_antecipada');
  lbid_boleto_digital := TLabel.Create('view.boletos.form.lbid_boleto_digital');
  edid_boleto_digital := TDBEdit.Create('view.boletos.form.edid_boleto_digital');
  lbboleto_digital := TLabel.Create('view.boletos.form.lbboleto_digital');
  edboleto_digital := TDBEdit.Create('view.boletos.form.edboleto_digital');
  lbid_externo := TLabel.Create('view.boletos.form.lbid_externo');
  edid_externo := TDBEdit.Create('view.boletos.form.edid_externo');
  lbnumero_titulo_cliente := TLabel.Create('view.boletos.form.lbnumero_titulo_cliente');
  ednumero_titulo_cliente := TDBEdit.Create('view.boletos.form.ednumero_titulo_cliente');
  lburl_boleto := TLabel.Create('view.boletos.form.lburl_boleto');
  edurl_boleto := TDBEdit.Create('view.boletos.form.edurl_boleto');
  lbcodigo_interno := TLabel.Create('view.boletos.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.boletos.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.boletos.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.boletos.form.edexcluido');
  lbinclusao := TLabel.Create('view.boletos.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.boletos.form.edinclusao');
  lbalteracao := TLabel.Create('view.boletos.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.boletos.form.edalteracao');
  lbexclusao := TLabel.Create('view.boletos.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.boletos.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  BoletosDataset := TXDataWebDataSet.Create(Self);
  BoletosDatasetid := TIntegerField.Create(Self);
  BoletosDatasetaliado_id := TIntegerField.Create(Self);
  BoletosDatasetdata_base_id := TIntegerField.Create(Self);
  BoletosDatasetcliente_id := TIntegerField.Create(Self);
  BoletosDatasetconta_id := TIntegerField.Create(Self);
  BoletosDatasetfuncionario_id := TIntegerField.Create(Self);
  BoletosDatasetstatus_titulo_id := TIntegerField.Create(Self);
  BoletosDatasetvalor := TFloatField.Create(Self);
  BoletosDatasetdata_vencimento := TDateTimeField.Create(Self);
  BoletosDatasetdata_processamento := TDateTimeField.Create(Self);
  BoletosDatasetnosso_numero := TStringField.Create(Self);
  BoletosDatasetnosso_numero_dv := TStringField.Create(Self);
  BoletosDatasetlinha_digitavel := TStringField.Create(Self);
  BoletosDatasetcodigo_barras := TStringField.Create(Self);
  BoletosDatasetbanco_carteira_id := TIntegerField.Create(Self);
  BoletosDatasetdocumento := TStringField.Create(Self);
  BoletosDatasetmensagem1 := TStringField.Create(Self);
  BoletosDatasetmensagem2 := TStringField.Create(Self);
  BoletosDatasetmensagem3 := TStringField.Create(Self);
  BoletosDatasettaxa_juros := TFloatField.Create(Self);
  BoletosDatasettaxa_multa := TFloatField.Create(Self);
  BoletosDatasetarquivo_retorno := TStringField.Create(Self);
  BoletosDatasetdata_retorno := TDateTimeField.Create(Self);
  BoletosDatasetdata_emissao := TDateTimeField.Create(Self);
  BoletosDatasetcodigo_carteira := TIntegerField.Create(Self);
  BoletosDatasetparcela := TStringField.Create(Self);
  BoletosDatasetdata_pagamento := TDateTimeField.Create(Self);
  BoletosDatasetvalor_pago := TFloatField.Create(Self);
  BoletosDatasetvalor_novo := TFloatField.Create(Self);
  BoletosDatasetdata_vencimento_nova := TDateTimeField.Create(Self);
  BoletosDatasettipo_liquidacao_antecipada := TIntegerField.Create(Self);
  BoletosDatasetid_boleto_digital := TStringField.Create(Self);
  BoletosDatasetboleto_digital := TBooleanField.Create(Self);
  BoletosDatasetid_externo := TStringField.Create(Self);
  BoletosDatasetnumero_titulo_cliente := TStringField.Create(Self);
  BoletosDataseturl_boleto := TStringField.Create(Self);
  BoletosDatasetcodigo_interno := TIntegerField.Create(Self);
  BoletosDatasetexcluido := TBooleanField.Create(Self);
  BoletosDatasetinclusao := TDateTimeField.Create(Self);
  BoletosDatasetalteracao := TDateTimeField.Create(Self);
  BoletosDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientBoletosGet := TXDataWebClient.Create(Self);
  XDataClientBoletosDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbcliente_id.BeforeLoadDFMValues;
  edcliente_id.BeforeLoadDFMValues;
  lbconta_id.BeforeLoadDFMValues;
  edconta_id.BeforeLoadDFMValues;
  lbfuncionario_id.BeforeLoadDFMValues;
  edfuncionario_id.BeforeLoadDFMValues;
  lbstatus_titulo_id.BeforeLoadDFMValues;
  edstatus_titulo_id.BeforeLoadDFMValues;
  lbvalor.BeforeLoadDFMValues;
  edvalor.BeforeLoadDFMValues;
  lbdata_vencimento.BeforeLoadDFMValues;
  eddata_vencimento.BeforeLoadDFMValues;
  lbdata_processamento.BeforeLoadDFMValues;
  eddata_processamento.BeforeLoadDFMValues;
  lbnosso_numero.BeforeLoadDFMValues;
  ednosso_numero.BeforeLoadDFMValues;
  lbnosso_numero_dv.BeforeLoadDFMValues;
  ednosso_numero_dv.BeforeLoadDFMValues;
  lblinha_digitavel.BeforeLoadDFMValues;
  edlinha_digitavel.BeforeLoadDFMValues;
  lbcodigo_barras.BeforeLoadDFMValues;
  edcodigo_barras.BeforeLoadDFMValues;
  lbbanco_carteira_id.BeforeLoadDFMValues;
  edbanco_carteira_id.BeforeLoadDFMValues;
  lbdocumento.BeforeLoadDFMValues;
  eddocumento.BeforeLoadDFMValues;
  lbmensagem1.BeforeLoadDFMValues;
  edmensagem1.BeforeLoadDFMValues;
  lbmensagem2.BeforeLoadDFMValues;
  edmensagem2.BeforeLoadDFMValues;
  lbmensagem3.BeforeLoadDFMValues;
  edmensagem3.BeforeLoadDFMValues;
  lbtaxa_juros.BeforeLoadDFMValues;
  edtaxa_juros.BeforeLoadDFMValues;
  lbtaxa_multa.BeforeLoadDFMValues;
  edtaxa_multa.BeforeLoadDFMValues;
  lbarquivo_retorno.BeforeLoadDFMValues;
  edarquivo_retorno.BeforeLoadDFMValues;
  lbdata_retorno.BeforeLoadDFMValues;
  eddata_retorno.BeforeLoadDFMValues;
  lbdata_emissao.BeforeLoadDFMValues;
  eddata_emissao.BeforeLoadDFMValues;
  lbcodigo_carteira.BeforeLoadDFMValues;
  edcodigo_carteira.BeforeLoadDFMValues;
  lbparcela.BeforeLoadDFMValues;
  edparcela.BeforeLoadDFMValues;
  lbdata_pagamento.BeforeLoadDFMValues;
  eddata_pagamento.BeforeLoadDFMValues;
  lbvalor_pago.BeforeLoadDFMValues;
  edvalor_pago.BeforeLoadDFMValues;
  lbvalor_novo.BeforeLoadDFMValues;
  edvalor_novo.BeforeLoadDFMValues;
  lbdata_vencimento_nova.BeforeLoadDFMValues;
  eddata_vencimento_nova.BeforeLoadDFMValues;
  lbtipo_liquidacao_antecipada.BeforeLoadDFMValues;
  edtipo_liquidacao_antecipada.BeforeLoadDFMValues;
  lbid_boleto_digital.BeforeLoadDFMValues;
  edid_boleto_digital.BeforeLoadDFMValues;
  lbboleto_digital.BeforeLoadDFMValues;
  edboleto_digital.BeforeLoadDFMValues;
  lbid_externo.BeforeLoadDFMValues;
  edid_externo.BeforeLoadDFMValues;
  lbnumero_titulo_cliente.BeforeLoadDFMValues;
  ednumero_titulo_cliente.BeforeLoadDFMValues;
  lburl_boleto.BeforeLoadDFMValues;
  edurl_boleto.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  BoletosDataset.BeforeLoadDFMValues;
  BoletosDatasetid.BeforeLoadDFMValues;
  BoletosDatasetaliado_id.BeforeLoadDFMValues;
  BoletosDatasetdata_base_id.BeforeLoadDFMValues;
  BoletosDatasetcliente_id.BeforeLoadDFMValues;
  BoletosDatasetconta_id.BeforeLoadDFMValues;
  BoletosDatasetfuncionario_id.BeforeLoadDFMValues;
  BoletosDatasetstatus_titulo_id.BeforeLoadDFMValues;
  BoletosDatasetvalor.BeforeLoadDFMValues;
  BoletosDatasetdata_vencimento.BeforeLoadDFMValues;
  BoletosDatasetdata_processamento.BeforeLoadDFMValues;
  BoletosDatasetnosso_numero.BeforeLoadDFMValues;
  BoletosDatasetnosso_numero_dv.BeforeLoadDFMValues;
  BoletosDatasetlinha_digitavel.BeforeLoadDFMValues;
  BoletosDatasetcodigo_barras.BeforeLoadDFMValues;
  BoletosDatasetbanco_carteira_id.BeforeLoadDFMValues;
  BoletosDatasetdocumento.BeforeLoadDFMValues;
  BoletosDatasetmensagem1.BeforeLoadDFMValues;
  BoletosDatasetmensagem2.BeforeLoadDFMValues;
  BoletosDatasetmensagem3.BeforeLoadDFMValues;
  BoletosDatasettaxa_juros.BeforeLoadDFMValues;
  BoletosDatasettaxa_multa.BeforeLoadDFMValues;
  BoletosDatasetarquivo_retorno.BeforeLoadDFMValues;
  BoletosDatasetdata_retorno.BeforeLoadDFMValues;
  BoletosDatasetdata_emissao.BeforeLoadDFMValues;
  BoletosDatasetcodigo_carteira.BeforeLoadDFMValues;
  BoletosDatasetparcela.BeforeLoadDFMValues;
  BoletosDatasetdata_pagamento.BeforeLoadDFMValues;
  BoletosDatasetvalor_pago.BeforeLoadDFMValues;
  BoletosDatasetvalor_novo.BeforeLoadDFMValues;
  BoletosDatasetdata_vencimento_nova.BeforeLoadDFMValues;
  BoletosDatasettipo_liquidacao_antecipada.BeforeLoadDFMValues;
  BoletosDatasetid_boleto_digital.BeforeLoadDFMValues;
  BoletosDatasetboleto_digital.BeforeLoadDFMValues;
  BoletosDatasetid_externo.BeforeLoadDFMValues;
  BoletosDatasetnumero_titulo_cliente.BeforeLoadDFMValues;
  BoletosDataseturl_boleto.BeforeLoadDFMValues;
  BoletosDatasetcodigo_interno.BeforeLoadDFMValues;
  BoletosDatasetexcluido.BeforeLoadDFMValues;
  BoletosDatasetinclusao.BeforeLoadDFMValues;
  BoletosDatasetalteracao.BeforeLoadDFMValues;
  BoletosDatasetexclusao.BeforeLoadDFMValues;
  XDataClientBoletosGet.BeforeLoadDFMValues;
  XDataClientBoletosDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewBoletosEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 1372;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 1312;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 1312;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 1312;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbcliente_id.SetParentComponent(Self);
    lbcliente_id.Name := 'lbcliente_id';
    lbcliente_id.Left := 24;
    lbcliente_id.Top := 273;
    lbcliente_id.Width := 14;
    lbcliente_id.Height := 13;
    lbcliente_id.Caption := 'cliente_id:';
    lbcliente_id.Transparent := True;
    edcliente_id.SetParentComponent(Self);
    edcliente_id.Name := 'edcliente_id';
    edcliente_id.Left := 221;
    edcliente_id.Top := 270;
    edcliente_id.Width := 200;
    edcliente_id.Height := 21;
    edcliente_id.Enabled := True;
    edcliente_id.TabOrder := 9;
    edcliente_id.Text := 'edcliente_id';
    edcliente_id.DataField := 'cliente_id';
    edcliente_id.DataSource := DataSource;
    lbconta_id.SetParentComponent(Self);
    lbconta_id.Name := 'lbconta_id';
    lbconta_id.Left := 24;
    lbconta_id.Top := 300;
    lbconta_id.Width := 14;
    lbconta_id.Height := 13;
    lbconta_id.Caption := 'conta_id:';
    lbconta_id.Transparent := True;
    edconta_id.SetParentComponent(Self);
    edconta_id.Name := 'edconta_id';
    edconta_id.Left := 221;
    edconta_id.Top := 297;
    edconta_id.Width := 200;
    edconta_id.Height := 21;
    edconta_id.Enabled := True;
    edconta_id.TabOrder := 10;
    edconta_id.Text := 'edconta_id';
    edconta_id.DataField := 'conta_id';
    edconta_id.DataSource := DataSource;
    lbfuncionario_id.SetParentComponent(Self);
    lbfuncionario_id.Name := 'lbfuncionario_id';
    lbfuncionario_id.Left := 24;
    lbfuncionario_id.Top := 327;
    lbfuncionario_id.Width := 14;
    lbfuncionario_id.Height := 13;
    lbfuncionario_id.Caption := 'funcionario_id:';
    lbfuncionario_id.Transparent := True;
    edfuncionario_id.SetParentComponent(Self);
    edfuncionario_id.Name := 'edfuncionario_id';
    edfuncionario_id.Left := 221;
    edfuncionario_id.Top := 324;
    edfuncionario_id.Width := 200;
    edfuncionario_id.Height := 21;
    edfuncionario_id.Enabled := True;
    edfuncionario_id.TabOrder := 11;
    edfuncionario_id.Text := 'edfuncionario_id';
    edfuncionario_id.DataField := 'funcionario_id';
    edfuncionario_id.DataSource := DataSource;
    lbstatus_titulo_id.SetParentComponent(Self);
    lbstatus_titulo_id.Name := 'lbstatus_titulo_id';
    lbstatus_titulo_id.Left := 24;
    lbstatus_titulo_id.Top := 354;
    lbstatus_titulo_id.Width := 14;
    lbstatus_titulo_id.Height := 13;
    lbstatus_titulo_id.Caption := 'status_titulo_id:';
    lbstatus_titulo_id.Transparent := True;
    edstatus_titulo_id.SetParentComponent(Self);
    edstatus_titulo_id.Name := 'edstatus_titulo_id';
    edstatus_titulo_id.Left := 221;
    edstatus_titulo_id.Top := 351;
    edstatus_titulo_id.Width := 200;
    edstatus_titulo_id.Height := 21;
    edstatus_titulo_id.Enabled := True;
    edstatus_titulo_id.TabOrder := 12;
    edstatus_titulo_id.Text := 'edstatus_titulo_id';
    edstatus_titulo_id.DataField := 'status_titulo_id';
    edstatus_titulo_id.DataSource := DataSource;
    lbvalor.SetParentComponent(Self);
    lbvalor.Name := 'lbvalor';
    lbvalor.Left := 24;
    lbvalor.Top := 381;
    lbvalor.Width := 14;
    lbvalor.Height := 13;
    lbvalor.Caption := 'valor:';
    lbvalor.Transparent := True;
    edvalor.SetParentComponent(Self);
    edvalor.Name := 'edvalor';
    edvalor.Left := 221;
    edvalor.Top := 378;
    edvalor.Width := 200;
    edvalor.Height := 21;
    edvalor.Enabled := True;
    edvalor.TabOrder := 13;
    edvalor.Text := 'edvalor';
    edvalor.DataField := 'valor';
    edvalor.DataSource := DataSource;
    lbdata_vencimento.SetParentComponent(Self);
    lbdata_vencimento.Name := 'lbdata_vencimento';
    lbdata_vencimento.Left := 24;
    lbdata_vencimento.Top := 408;
    lbdata_vencimento.Width := 14;
    lbdata_vencimento.Height := 13;
    lbdata_vencimento.Caption := 'data_vencimento:';
    lbdata_vencimento.Transparent := True;
    eddata_vencimento.SetParentComponent(Self);
    eddata_vencimento.Name := 'eddata_vencimento';
    eddata_vencimento.Left := 221;
    eddata_vencimento.Top := 405;
    eddata_vencimento.Width := 200;
    eddata_vencimento.Height := 21;
    eddata_vencimento.Enabled := True;
    eddata_vencimento.TabOrder := 14;
    eddata_vencimento.Text := 'eddata_vencimento';
    eddata_vencimento.DataField := 'data_vencimento';
    eddata_vencimento.DataSource := DataSource;
    lbdata_processamento.SetParentComponent(Self);
    lbdata_processamento.Name := 'lbdata_processamento';
    lbdata_processamento.Left := 24;
    lbdata_processamento.Top := 435;
    lbdata_processamento.Width := 14;
    lbdata_processamento.Height := 13;
    lbdata_processamento.Caption := 'data_processamento:';
    lbdata_processamento.Transparent := True;
    eddata_processamento.SetParentComponent(Self);
    eddata_processamento.Name := 'eddata_processamento';
    eddata_processamento.Left := 221;
    eddata_processamento.Top := 432;
    eddata_processamento.Width := 200;
    eddata_processamento.Height := 21;
    eddata_processamento.Enabled := True;
    eddata_processamento.TabOrder := 15;
    eddata_processamento.Text := 'eddata_processamento';
    eddata_processamento.DataField := 'data_processamento';
    eddata_processamento.DataSource := DataSource;
    lbnosso_numero.SetParentComponent(Self);
    lbnosso_numero.Name := 'lbnosso_numero';
    lbnosso_numero.Left := 24;
    lbnosso_numero.Top := 462;
    lbnosso_numero.Width := 14;
    lbnosso_numero.Height := 13;
    lbnosso_numero.Caption := 'nosso_numero:';
    lbnosso_numero.Transparent := True;
    ednosso_numero.SetParentComponent(Self);
    ednosso_numero.Name := 'ednosso_numero';
    ednosso_numero.Left := 221;
    ednosso_numero.Top := 459;
    ednosso_numero.Width := 200;
    ednosso_numero.Height := 21;
    ednosso_numero.Enabled := True;
    ednosso_numero.TabOrder := 16;
    ednosso_numero.Text := 'ednosso_numero';
    ednosso_numero.DataField := 'nosso_numero';
    ednosso_numero.DataSource := DataSource;
    lbnosso_numero_dv.SetParentComponent(Self);
    lbnosso_numero_dv.Name := 'lbnosso_numero_dv';
    lbnosso_numero_dv.Left := 24;
    lbnosso_numero_dv.Top := 489;
    lbnosso_numero_dv.Width := 14;
    lbnosso_numero_dv.Height := 13;
    lbnosso_numero_dv.Caption := 'nosso_numero_dv:';
    lbnosso_numero_dv.Transparent := True;
    ednosso_numero_dv.SetParentComponent(Self);
    ednosso_numero_dv.Name := 'ednosso_numero_dv';
    ednosso_numero_dv.Left := 221;
    ednosso_numero_dv.Top := 486;
    ednosso_numero_dv.Width := 200;
    ednosso_numero_dv.Height := 21;
    ednosso_numero_dv.Enabled := True;
    ednosso_numero_dv.TabOrder := 17;
    ednosso_numero_dv.Text := 'ednosso_numero_dv';
    ednosso_numero_dv.DataField := 'nosso_numero_dv';
    ednosso_numero_dv.DataSource := DataSource;
    lblinha_digitavel.SetParentComponent(Self);
    lblinha_digitavel.Name := 'lblinha_digitavel';
    lblinha_digitavel.Left := 24;
    lblinha_digitavel.Top := 516;
    lblinha_digitavel.Width := 14;
    lblinha_digitavel.Height := 13;
    lblinha_digitavel.Caption := 'linha_digitavel:';
    lblinha_digitavel.Transparent := True;
    edlinha_digitavel.SetParentComponent(Self);
    edlinha_digitavel.Name := 'edlinha_digitavel';
    edlinha_digitavel.Left := 221;
    edlinha_digitavel.Top := 513;
    edlinha_digitavel.Width := 200;
    edlinha_digitavel.Height := 21;
    edlinha_digitavel.Enabled := True;
    edlinha_digitavel.TabOrder := 18;
    edlinha_digitavel.Text := 'edlinha_digitavel';
    edlinha_digitavel.DataField := 'linha_digitavel';
    edlinha_digitavel.DataSource := DataSource;
    lbcodigo_barras.SetParentComponent(Self);
    lbcodigo_barras.Name := 'lbcodigo_barras';
    lbcodigo_barras.Left := 24;
    lbcodigo_barras.Top := 543;
    lbcodigo_barras.Width := 14;
    lbcodigo_barras.Height := 13;
    lbcodigo_barras.Caption := 'codigo_barras:';
    lbcodigo_barras.Transparent := True;
    edcodigo_barras.SetParentComponent(Self);
    edcodigo_barras.Name := 'edcodigo_barras';
    edcodigo_barras.Left := 221;
    edcodigo_barras.Top := 540;
    edcodigo_barras.Width := 200;
    edcodigo_barras.Height := 21;
    edcodigo_barras.Enabled := True;
    edcodigo_barras.TabOrder := 19;
    edcodigo_barras.Text := 'edcodigo_barras';
    edcodigo_barras.DataField := 'codigo_barras';
    edcodigo_barras.DataSource := DataSource;
    lbbanco_carteira_id.SetParentComponent(Self);
    lbbanco_carteira_id.Name := 'lbbanco_carteira_id';
    lbbanco_carteira_id.Left := 24;
    lbbanco_carteira_id.Top := 570;
    lbbanco_carteira_id.Width := 14;
    lbbanco_carteira_id.Height := 13;
    lbbanco_carteira_id.Caption := 'banco_carteira_id:';
    lbbanco_carteira_id.Transparent := True;
    edbanco_carteira_id.SetParentComponent(Self);
    edbanco_carteira_id.Name := 'edbanco_carteira_id';
    edbanco_carteira_id.Left := 221;
    edbanco_carteira_id.Top := 567;
    edbanco_carteira_id.Width := 200;
    edbanco_carteira_id.Height := 21;
    edbanco_carteira_id.Enabled := True;
    edbanco_carteira_id.TabOrder := 20;
    edbanco_carteira_id.Text := 'edbanco_carteira_id';
    edbanco_carteira_id.DataField := 'banco_carteira_id';
    edbanco_carteira_id.DataSource := DataSource;
    lbdocumento.SetParentComponent(Self);
    lbdocumento.Name := 'lbdocumento';
    lbdocumento.Left := 24;
    lbdocumento.Top := 597;
    lbdocumento.Width := 14;
    lbdocumento.Height := 13;
    lbdocumento.Caption := 'documento:';
    lbdocumento.Transparent := True;
    eddocumento.SetParentComponent(Self);
    eddocumento.Name := 'eddocumento';
    eddocumento.Left := 221;
    eddocumento.Top := 594;
    eddocumento.Width := 200;
    eddocumento.Height := 21;
    eddocumento.Enabled := True;
    eddocumento.TabOrder := 21;
    eddocumento.Text := 'eddocumento';
    eddocumento.DataField := 'documento';
    eddocumento.DataSource := DataSource;
    lbmensagem1.SetParentComponent(Self);
    lbmensagem1.Name := 'lbmensagem1';
    lbmensagem1.Left := 24;
    lbmensagem1.Top := 624;
    lbmensagem1.Width := 14;
    lbmensagem1.Height := 13;
    lbmensagem1.Caption := 'mensagem1:';
    lbmensagem1.Transparent := True;
    edmensagem1.SetParentComponent(Self);
    edmensagem1.Name := 'edmensagem1';
    edmensagem1.Left := 221;
    edmensagem1.Top := 621;
    edmensagem1.Width := 200;
    edmensagem1.Height := 21;
    edmensagem1.Enabled := True;
    edmensagem1.TabOrder := 22;
    edmensagem1.Text := 'edmensagem1';
    edmensagem1.DataField := 'mensagem1';
    edmensagem1.DataSource := DataSource;
    lbmensagem2.SetParentComponent(Self);
    lbmensagem2.Name := 'lbmensagem2';
    lbmensagem2.Left := 24;
    lbmensagem2.Top := 651;
    lbmensagem2.Width := 14;
    lbmensagem2.Height := 13;
    lbmensagem2.Caption := 'mensagem2:';
    lbmensagem2.Transparent := True;
    edmensagem2.SetParentComponent(Self);
    edmensagem2.Name := 'edmensagem2';
    edmensagem2.Left := 221;
    edmensagem2.Top := 648;
    edmensagem2.Width := 200;
    edmensagem2.Height := 21;
    edmensagem2.Enabled := True;
    edmensagem2.TabOrder := 23;
    edmensagem2.Text := 'edmensagem2';
    edmensagem2.DataField := 'mensagem2';
    edmensagem2.DataSource := DataSource;
    lbmensagem3.SetParentComponent(Self);
    lbmensagem3.Name := 'lbmensagem3';
    lbmensagem3.Left := 24;
    lbmensagem3.Top := 678;
    lbmensagem3.Width := 14;
    lbmensagem3.Height := 13;
    lbmensagem3.Caption := 'mensagem3:';
    lbmensagem3.Transparent := True;
    edmensagem3.SetParentComponent(Self);
    edmensagem3.Name := 'edmensagem3';
    edmensagem3.Left := 221;
    edmensagem3.Top := 675;
    edmensagem3.Width := 200;
    edmensagem3.Height := 21;
    edmensagem3.Enabled := True;
    edmensagem3.TabOrder := 24;
    edmensagem3.Text := 'edmensagem3';
    edmensagem3.DataField := 'mensagem3';
    edmensagem3.DataSource := DataSource;
    lbtaxa_juros.SetParentComponent(Self);
    lbtaxa_juros.Name := 'lbtaxa_juros';
    lbtaxa_juros.Left := 24;
    lbtaxa_juros.Top := 705;
    lbtaxa_juros.Width := 14;
    lbtaxa_juros.Height := 13;
    lbtaxa_juros.Caption := 'taxa_juros:';
    lbtaxa_juros.Transparent := True;
    edtaxa_juros.SetParentComponent(Self);
    edtaxa_juros.Name := 'edtaxa_juros';
    edtaxa_juros.Left := 221;
    edtaxa_juros.Top := 702;
    edtaxa_juros.Width := 200;
    edtaxa_juros.Height := 21;
    edtaxa_juros.Enabled := True;
    edtaxa_juros.TabOrder := 25;
    edtaxa_juros.Text := 'edtaxa_juros';
    edtaxa_juros.DataField := 'taxa_juros';
    edtaxa_juros.DataSource := DataSource;
    lbtaxa_multa.SetParentComponent(Self);
    lbtaxa_multa.Name := 'lbtaxa_multa';
    lbtaxa_multa.Left := 24;
    lbtaxa_multa.Top := 732;
    lbtaxa_multa.Width := 14;
    lbtaxa_multa.Height := 13;
    lbtaxa_multa.Caption := 'taxa_multa:';
    lbtaxa_multa.Transparent := True;
    edtaxa_multa.SetParentComponent(Self);
    edtaxa_multa.Name := 'edtaxa_multa';
    edtaxa_multa.Left := 221;
    edtaxa_multa.Top := 729;
    edtaxa_multa.Width := 200;
    edtaxa_multa.Height := 21;
    edtaxa_multa.Enabled := True;
    edtaxa_multa.TabOrder := 26;
    edtaxa_multa.Text := 'edtaxa_multa';
    edtaxa_multa.DataField := 'taxa_multa';
    edtaxa_multa.DataSource := DataSource;
    lbarquivo_retorno.SetParentComponent(Self);
    lbarquivo_retorno.Name := 'lbarquivo_retorno';
    lbarquivo_retorno.Left := 24;
    lbarquivo_retorno.Top := 759;
    lbarquivo_retorno.Width := 14;
    lbarquivo_retorno.Height := 13;
    lbarquivo_retorno.Caption := 'arquivo_retorno:';
    lbarquivo_retorno.Transparent := True;
    edarquivo_retorno.SetParentComponent(Self);
    edarquivo_retorno.Name := 'edarquivo_retorno';
    edarquivo_retorno.Left := 221;
    edarquivo_retorno.Top := 756;
    edarquivo_retorno.Width := 200;
    edarquivo_retorno.Height := 21;
    edarquivo_retorno.Enabled := True;
    edarquivo_retorno.TabOrder := 27;
    edarquivo_retorno.Text := 'edarquivo_retorno';
    edarquivo_retorno.DataField := 'arquivo_retorno';
    edarquivo_retorno.DataSource := DataSource;
    lbdata_retorno.SetParentComponent(Self);
    lbdata_retorno.Name := 'lbdata_retorno';
    lbdata_retorno.Left := 24;
    lbdata_retorno.Top := 786;
    lbdata_retorno.Width := 14;
    lbdata_retorno.Height := 13;
    lbdata_retorno.Caption := 'data_retorno:';
    lbdata_retorno.Transparent := True;
    eddata_retorno.SetParentComponent(Self);
    eddata_retorno.Name := 'eddata_retorno';
    eddata_retorno.Left := 221;
    eddata_retorno.Top := 783;
    eddata_retorno.Width := 200;
    eddata_retorno.Height := 21;
    eddata_retorno.Enabled := True;
    eddata_retorno.TabOrder := 28;
    eddata_retorno.Text := 'eddata_retorno';
    eddata_retorno.DataField := 'data_retorno';
    eddata_retorno.DataSource := DataSource;
    lbdata_emissao.SetParentComponent(Self);
    lbdata_emissao.Name := 'lbdata_emissao';
    lbdata_emissao.Left := 24;
    lbdata_emissao.Top := 813;
    lbdata_emissao.Width := 14;
    lbdata_emissao.Height := 13;
    lbdata_emissao.Caption := 'data_emissao:';
    lbdata_emissao.Transparent := True;
    eddata_emissao.SetParentComponent(Self);
    eddata_emissao.Name := 'eddata_emissao';
    eddata_emissao.Left := 221;
    eddata_emissao.Top := 810;
    eddata_emissao.Width := 200;
    eddata_emissao.Height := 21;
    eddata_emissao.Enabled := True;
    eddata_emissao.TabOrder := 29;
    eddata_emissao.Text := 'eddata_emissao';
    eddata_emissao.DataField := 'data_emissao';
    eddata_emissao.DataSource := DataSource;
    lbcodigo_carteira.SetParentComponent(Self);
    lbcodigo_carteira.Name := 'lbcodigo_carteira';
    lbcodigo_carteira.Left := 24;
    lbcodigo_carteira.Top := 840;
    lbcodigo_carteira.Width := 14;
    lbcodigo_carteira.Height := 13;
    lbcodigo_carteira.Caption := 'codigo_carteira:';
    lbcodigo_carteira.Transparent := True;
    edcodigo_carteira.SetParentComponent(Self);
    edcodigo_carteira.Name := 'edcodigo_carteira';
    edcodigo_carteira.Left := 221;
    edcodigo_carteira.Top := 837;
    edcodigo_carteira.Width := 200;
    edcodigo_carteira.Height := 21;
    edcodigo_carteira.Enabled := True;
    edcodigo_carteira.TabOrder := 30;
    edcodigo_carteira.Text := 'edcodigo_carteira';
    edcodigo_carteira.DataField := 'codigo_carteira';
    edcodigo_carteira.DataSource := DataSource;
    lbparcela.SetParentComponent(Self);
    lbparcela.Name := 'lbparcela';
    lbparcela.Left := 24;
    lbparcela.Top := 867;
    lbparcela.Width := 14;
    lbparcela.Height := 13;
    lbparcela.Caption := 'parcela:';
    lbparcela.Transparent := True;
    edparcela.SetParentComponent(Self);
    edparcela.Name := 'edparcela';
    edparcela.Left := 221;
    edparcela.Top := 864;
    edparcela.Width := 200;
    edparcela.Height := 21;
    edparcela.Enabled := True;
    edparcela.TabOrder := 31;
    edparcela.Text := 'edparcela';
    edparcela.DataField := 'parcela';
    edparcela.DataSource := DataSource;
    lbdata_pagamento.SetParentComponent(Self);
    lbdata_pagamento.Name := 'lbdata_pagamento';
    lbdata_pagamento.Left := 24;
    lbdata_pagamento.Top := 894;
    lbdata_pagamento.Width := 14;
    lbdata_pagamento.Height := 13;
    lbdata_pagamento.Caption := 'data_pagamento:';
    lbdata_pagamento.Transparent := True;
    eddata_pagamento.SetParentComponent(Self);
    eddata_pagamento.Name := 'eddata_pagamento';
    eddata_pagamento.Left := 221;
    eddata_pagamento.Top := 891;
    eddata_pagamento.Width := 200;
    eddata_pagamento.Height := 21;
    eddata_pagamento.Enabled := True;
    eddata_pagamento.TabOrder := 32;
    eddata_pagamento.Text := 'eddata_pagamento';
    eddata_pagamento.DataField := 'data_pagamento';
    eddata_pagamento.DataSource := DataSource;
    lbvalor_pago.SetParentComponent(Self);
    lbvalor_pago.Name := 'lbvalor_pago';
    lbvalor_pago.Left := 24;
    lbvalor_pago.Top := 921;
    lbvalor_pago.Width := 14;
    lbvalor_pago.Height := 13;
    lbvalor_pago.Caption := 'valor_pago:';
    lbvalor_pago.Transparent := True;
    edvalor_pago.SetParentComponent(Self);
    edvalor_pago.Name := 'edvalor_pago';
    edvalor_pago.Left := 221;
    edvalor_pago.Top := 918;
    edvalor_pago.Width := 200;
    edvalor_pago.Height := 21;
    edvalor_pago.Enabled := True;
    edvalor_pago.TabOrder := 33;
    edvalor_pago.Text := 'edvalor_pago';
    edvalor_pago.DataField := 'valor_pago';
    edvalor_pago.DataSource := DataSource;
    lbvalor_novo.SetParentComponent(Self);
    lbvalor_novo.Name := 'lbvalor_novo';
    lbvalor_novo.Left := 24;
    lbvalor_novo.Top := 948;
    lbvalor_novo.Width := 14;
    lbvalor_novo.Height := 13;
    lbvalor_novo.Caption := 'valor_novo:';
    lbvalor_novo.Transparent := True;
    edvalor_novo.SetParentComponent(Self);
    edvalor_novo.Name := 'edvalor_novo';
    edvalor_novo.Left := 221;
    edvalor_novo.Top := 945;
    edvalor_novo.Width := 200;
    edvalor_novo.Height := 21;
    edvalor_novo.Enabled := True;
    edvalor_novo.TabOrder := 34;
    edvalor_novo.Text := 'edvalor_novo';
    edvalor_novo.DataField := 'valor_novo';
    edvalor_novo.DataSource := DataSource;
    lbdata_vencimento_nova.SetParentComponent(Self);
    lbdata_vencimento_nova.Name := 'lbdata_vencimento_nova';
    lbdata_vencimento_nova.Left := 24;
    lbdata_vencimento_nova.Top := 975;
    lbdata_vencimento_nova.Width := 14;
    lbdata_vencimento_nova.Height := 13;
    lbdata_vencimento_nova.Caption := 'data_vencimento_nova:';
    lbdata_vencimento_nova.Transparent := True;
    eddata_vencimento_nova.SetParentComponent(Self);
    eddata_vencimento_nova.Name := 'eddata_vencimento_nova';
    eddata_vencimento_nova.Left := 221;
    eddata_vencimento_nova.Top := 972;
    eddata_vencimento_nova.Width := 200;
    eddata_vencimento_nova.Height := 21;
    eddata_vencimento_nova.Enabled := True;
    eddata_vencimento_nova.TabOrder := 35;
    eddata_vencimento_nova.Text := 'eddata_vencimento_nova';
    eddata_vencimento_nova.DataField := 'data_vencimento_nova';
    eddata_vencimento_nova.DataSource := DataSource;
    lbtipo_liquidacao_antecipada.SetParentComponent(Self);
    lbtipo_liquidacao_antecipada.Name := 'lbtipo_liquidacao_antecipada';
    lbtipo_liquidacao_antecipada.Left := 24;
    lbtipo_liquidacao_antecipada.Top := 1002;
    lbtipo_liquidacao_antecipada.Width := 14;
    lbtipo_liquidacao_antecipada.Height := 13;
    lbtipo_liquidacao_antecipada.Caption := 'tipo_liquidacao_antecipada:';
    lbtipo_liquidacao_antecipada.Transparent := True;
    edtipo_liquidacao_antecipada.SetParentComponent(Self);
    edtipo_liquidacao_antecipada.Name := 'edtipo_liquidacao_antecipada';
    edtipo_liquidacao_antecipada.Left := 221;
    edtipo_liquidacao_antecipada.Top := 999;
    edtipo_liquidacao_antecipada.Width := 200;
    edtipo_liquidacao_antecipada.Height := 21;
    edtipo_liquidacao_antecipada.Enabled := True;
    edtipo_liquidacao_antecipada.TabOrder := 36;
    edtipo_liquidacao_antecipada.Text := 'edtipo_liquidacao_antecipada';
    edtipo_liquidacao_antecipada.DataField := 'tipo_liquidacao_antecipada';
    edtipo_liquidacao_antecipada.DataSource := DataSource;
    lbid_boleto_digital.SetParentComponent(Self);
    lbid_boleto_digital.Name := 'lbid_boleto_digital';
    lbid_boleto_digital.Left := 24;
    lbid_boleto_digital.Top := 1029;
    lbid_boleto_digital.Width := 14;
    lbid_boleto_digital.Height := 13;
    lbid_boleto_digital.Caption := 'id_boleto_digital:';
    lbid_boleto_digital.Transparent := True;
    edid_boleto_digital.SetParentComponent(Self);
    edid_boleto_digital.Name := 'edid_boleto_digital';
    edid_boleto_digital.Left := 221;
    edid_boleto_digital.Top := 1026;
    edid_boleto_digital.Width := 200;
    edid_boleto_digital.Height := 21;
    edid_boleto_digital.Enabled := True;
    edid_boleto_digital.TabOrder := 37;
    edid_boleto_digital.Text := 'edid_boleto_digital';
    edid_boleto_digital.DataField := 'id_boleto_digital';
    edid_boleto_digital.DataSource := DataSource;
    lbboleto_digital.SetParentComponent(Self);
    lbboleto_digital.Name := 'lbboleto_digital';
    lbboleto_digital.Left := 24;
    lbboleto_digital.Top := 1056;
    lbboleto_digital.Width := 14;
    lbboleto_digital.Height := 13;
    lbboleto_digital.Caption := 'boleto_digital:';
    lbboleto_digital.Transparent := True;
    edboleto_digital.SetParentComponent(Self);
    edboleto_digital.Name := 'edboleto_digital';
    edboleto_digital.Left := 221;
    edboleto_digital.Top := 1053;
    edboleto_digital.Width := 200;
    edboleto_digital.Height := 21;
    edboleto_digital.Enabled := True;
    edboleto_digital.TabOrder := 38;
    edboleto_digital.Text := 'edboleto_digital';
    edboleto_digital.DataField := 'boleto_digital';
    edboleto_digital.DataSource := DataSource;
    lbid_externo.SetParentComponent(Self);
    lbid_externo.Name := 'lbid_externo';
    lbid_externo.Left := 24;
    lbid_externo.Top := 1083;
    lbid_externo.Width := 14;
    lbid_externo.Height := 13;
    lbid_externo.Caption := 'id_externo:';
    lbid_externo.Transparent := True;
    edid_externo.SetParentComponent(Self);
    edid_externo.Name := 'edid_externo';
    edid_externo.Left := 221;
    edid_externo.Top := 1080;
    edid_externo.Width := 200;
    edid_externo.Height := 21;
    edid_externo.Enabled := True;
    edid_externo.TabOrder := 39;
    edid_externo.Text := 'edid_externo';
    edid_externo.DataField := 'id_externo';
    edid_externo.DataSource := DataSource;
    lbnumero_titulo_cliente.SetParentComponent(Self);
    lbnumero_titulo_cliente.Name := 'lbnumero_titulo_cliente';
    lbnumero_titulo_cliente.Left := 24;
    lbnumero_titulo_cliente.Top := 1110;
    lbnumero_titulo_cliente.Width := 14;
    lbnumero_titulo_cliente.Height := 13;
    lbnumero_titulo_cliente.Caption := 'numero_titulo_cliente:';
    lbnumero_titulo_cliente.Transparent := True;
    ednumero_titulo_cliente.SetParentComponent(Self);
    ednumero_titulo_cliente.Name := 'ednumero_titulo_cliente';
    ednumero_titulo_cliente.Left := 221;
    ednumero_titulo_cliente.Top := 1107;
    ednumero_titulo_cliente.Width := 200;
    ednumero_titulo_cliente.Height := 21;
    ednumero_titulo_cliente.Enabled := True;
    ednumero_titulo_cliente.TabOrder := 40;
    ednumero_titulo_cliente.Text := 'ednumero_titulo_cliente';
    ednumero_titulo_cliente.DataField := 'numero_titulo_cliente';
    ednumero_titulo_cliente.DataSource := DataSource;
    lburl_boleto.SetParentComponent(Self);
    lburl_boleto.Name := 'lburl_boleto';
    lburl_boleto.Left := 24;
    lburl_boleto.Top := 1137;
    lburl_boleto.Width := 14;
    lburl_boleto.Height := 13;
    lburl_boleto.Caption := 'url_boleto:';
    lburl_boleto.Transparent := True;
    edurl_boleto.SetParentComponent(Self);
    edurl_boleto.Name := 'edurl_boleto';
    edurl_boleto.Left := 221;
    edurl_boleto.Top := 1134;
    edurl_boleto.Width := 200;
    edurl_boleto.Height := 21;
    edurl_boleto.Enabled := True;
    edurl_boleto.TabOrder := 41;
    edurl_boleto.Text := 'edurl_boleto';
    edurl_boleto.DataField := 'url_boleto';
    edurl_boleto.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 1164;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 1161;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 42;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 1191;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 1188;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 43;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 1218;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 1215;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 44;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 1245;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 1242;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 45;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 1272;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 1269;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 46;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := BoletosDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    BoletosDataset.SetParentComponent(Self);
    BoletosDataset.Name := 'BoletosDataset';
    BoletosDataset.AfterApplyUpdates := BoletosDatasetAfterApplyUpdates;
    BoletosDataset.EntitySetName := 'Boletos';
    BoletosDataset.Connection := DMConnection.ApiConnection;
    BoletosDataset.Left := 176;
    BoletosDataset.Top := 8;
    BoletosDatasetid.SetParentComponent(BoletosDataset);
    BoletosDatasetid.Name := 'BoletosDatasetid';
    BoletosDatasetid.FieldName := 'id';
    BoletosDatasetid.Required := True;
    BoletosDatasetaliado_id.SetParentComponent(BoletosDataset);
    BoletosDatasetaliado_id.Name := 'BoletosDatasetaliado_id';
    BoletosDatasetaliado_id.FieldName := 'aliado_id';
    BoletosDatasetaliado_id.Required := True;
    BoletosDatasetdata_base_id.SetParentComponent(BoletosDataset);
    BoletosDatasetdata_base_id.Name := 'BoletosDatasetdata_base_id';
    BoletosDatasetdata_base_id.FieldName := 'data_base_id';
    BoletosDatasetdata_base_id.Required := True;
    BoletosDatasetcliente_id.SetParentComponent(BoletosDataset);
    BoletosDatasetcliente_id.Name := 'BoletosDatasetcliente_id';
    BoletosDatasetcliente_id.FieldName := 'cliente_id';
    BoletosDatasetcliente_id.Required := False;
    BoletosDatasetconta_id.SetParentComponent(BoletosDataset);
    BoletosDatasetconta_id.Name := 'BoletosDatasetconta_id';
    BoletosDatasetconta_id.FieldName := 'conta_id';
    BoletosDatasetconta_id.Required := False;
    BoletosDatasetfuncionario_id.SetParentComponent(BoletosDataset);
    BoletosDatasetfuncionario_id.Name := 'BoletosDatasetfuncionario_id';
    BoletosDatasetfuncionario_id.FieldName := 'funcionario_id';
    BoletosDatasetfuncionario_id.Required := False;
    BoletosDatasetstatus_titulo_id.SetParentComponent(BoletosDataset);
    BoletosDatasetstatus_titulo_id.Name := 'BoletosDatasetstatus_titulo_id';
    BoletosDatasetstatus_titulo_id.FieldName := 'status_titulo_id';
    BoletosDatasetstatus_titulo_id.Required := False;
    BoletosDatasetvalor.SetParentComponent(BoletosDataset);
    BoletosDatasetvalor.Name := 'BoletosDatasetvalor';
    BoletosDatasetvalor.FieldName := 'valor';
    BoletosDatasetvalor.Required := False;
    BoletosDatasetdata_vencimento.SetParentComponent(BoletosDataset);
    BoletosDatasetdata_vencimento.Name := 'BoletosDatasetdata_vencimento';
    BoletosDatasetdata_vencimento.FieldName := 'data_vencimento';
    BoletosDatasetdata_vencimento.Required := False;
    BoletosDatasetdata_processamento.SetParentComponent(BoletosDataset);
    BoletosDatasetdata_processamento.Name := 'BoletosDatasetdata_processamento';
    BoletosDatasetdata_processamento.FieldName := 'data_processamento';
    BoletosDatasetdata_processamento.Required := False;
    BoletosDatasetnosso_numero.SetParentComponent(BoletosDataset);
    BoletosDatasetnosso_numero.Name := 'BoletosDatasetnosso_numero';
    BoletosDatasetnosso_numero.FieldName := 'nosso_numero';
    BoletosDatasetnosso_numero.Required := False;
    BoletosDatasetnosso_numero.Size := 255;
    BoletosDatasetnosso_numero_dv.SetParentComponent(BoletosDataset);
    BoletosDatasetnosso_numero_dv.Name := 'BoletosDatasetnosso_numero_dv';
    BoletosDatasetnosso_numero_dv.FieldName := 'nosso_numero_dv';
    BoletosDatasetnosso_numero_dv.Required := False;
    BoletosDatasetnosso_numero_dv.Size := 255;
    BoletosDatasetlinha_digitavel.SetParentComponent(BoletosDataset);
    BoletosDatasetlinha_digitavel.Name := 'BoletosDatasetlinha_digitavel';
    BoletosDatasetlinha_digitavel.FieldName := 'linha_digitavel';
    BoletosDatasetlinha_digitavel.Required := False;
    BoletosDatasetlinha_digitavel.Size := 255;
    BoletosDatasetcodigo_barras.SetParentComponent(BoletosDataset);
    BoletosDatasetcodigo_barras.Name := 'BoletosDatasetcodigo_barras';
    BoletosDatasetcodigo_barras.FieldName := 'codigo_barras';
    BoletosDatasetcodigo_barras.Required := False;
    BoletosDatasetcodigo_barras.Size := 255;
    BoletosDatasetbanco_carteira_id.SetParentComponent(BoletosDataset);
    BoletosDatasetbanco_carteira_id.Name := 'BoletosDatasetbanco_carteira_id';
    BoletosDatasetbanco_carteira_id.FieldName := 'banco_carteira_id';
    BoletosDatasetbanco_carteira_id.Required := False;
    BoletosDatasetdocumento.SetParentComponent(BoletosDataset);
    BoletosDatasetdocumento.Name := 'BoletosDatasetdocumento';
    BoletosDatasetdocumento.FieldName := 'documento';
    BoletosDatasetdocumento.Required := False;
    BoletosDatasetdocumento.Size := 255;
    BoletosDatasetmensagem1.SetParentComponent(BoletosDataset);
    BoletosDatasetmensagem1.Name := 'BoletosDatasetmensagem1';
    BoletosDatasetmensagem1.FieldName := 'mensagem1';
    BoletosDatasetmensagem1.Required := False;
    BoletosDatasetmensagem1.Size := 255;
    BoletosDatasetmensagem2.SetParentComponent(BoletosDataset);
    BoletosDatasetmensagem2.Name := 'BoletosDatasetmensagem2';
    BoletosDatasetmensagem2.FieldName := 'mensagem2';
    BoletosDatasetmensagem2.Required := False;
    BoletosDatasetmensagem2.Size := 255;
    BoletosDatasetmensagem3.SetParentComponent(BoletosDataset);
    BoletosDatasetmensagem3.Name := 'BoletosDatasetmensagem3';
    BoletosDatasetmensagem3.FieldName := 'mensagem3';
    BoletosDatasetmensagem3.Required := False;
    BoletosDatasetmensagem3.Size := 255;
    BoletosDatasettaxa_juros.SetParentComponent(BoletosDataset);
    BoletosDatasettaxa_juros.Name := 'BoletosDatasettaxa_juros';
    BoletosDatasettaxa_juros.FieldName := 'taxa_juros';
    BoletosDatasettaxa_juros.Required := False;
    BoletosDatasettaxa_multa.SetParentComponent(BoletosDataset);
    BoletosDatasettaxa_multa.Name := 'BoletosDatasettaxa_multa';
    BoletosDatasettaxa_multa.FieldName := 'taxa_multa';
    BoletosDatasettaxa_multa.Required := False;
    BoletosDatasetarquivo_retorno.SetParentComponent(BoletosDataset);
    BoletosDatasetarquivo_retorno.Name := 'BoletosDatasetarquivo_retorno';
    BoletosDatasetarquivo_retorno.FieldName := 'arquivo_retorno';
    BoletosDatasetarquivo_retorno.Required := False;
    BoletosDatasetarquivo_retorno.Size := 255;
    BoletosDatasetdata_retorno.SetParentComponent(BoletosDataset);
    BoletosDatasetdata_retorno.Name := 'BoletosDatasetdata_retorno';
    BoletosDatasetdata_retorno.FieldName := 'data_retorno';
    BoletosDatasetdata_retorno.Required := False;
    BoletosDatasetdata_emissao.SetParentComponent(BoletosDataset);
    BoletosDatasetdata_emissao.Name := 'BoletosDatasetdata_emissao';
    BoletosDatasetdata_emissao.FieldName := 'data_emissao';
    BoletosDatasetdata_emissao.Required := False;
    BoletosDatasetcodigo_carteira.SetParentComponent(BoletosDataset);
    BoletosDatasetcodigo_carteira.Name := 'BoletosDatasetcodigo_carteira';
    BoletosDatasetcodigo_carteira.FieldName := 'codigo_carteira';
    BoletosDatasetcodigo_carteira.Required := False;
    BoletosDatasetparcela.SetParentComponent(BoletosDataset);
    BoletosDatasetparcela.Name := 'BoletosDatasetparcela';
    BoletosDatasetparcela.FieldName := 'parcela';
    BoletosDatasetparcela.Required := False;
    BoletosDatasetparcela.Size := 255;
    BoletosDatasetdata_pagamento.SetParentComponent(BoletosDataset);
    BoletosDatasetdata_pagamento.Name := 'BoletosDatasetdata_pagamento';
    BoletosDatasetdata_pagamento.FieldName := 'data_pagamento';
    BoletosDatasetdata_pagamento.Required := False;
    BoletosDatasetvalor_pago.SetParentComponent(BoletosDataset);
    BoletosDatasetvalor_pago.Name := 'BoletosDatasetvalor_pago';
    BoletosDatasetvalor_pago.FieldName := 'valor_pago';
    BoletosDatasetvalor_pago.Required := False;
    BoletosDatasetvalor_novo.SetParentComponent(BoletosDataset);
    BoletosDatasetvalor_novo.Name := 'BoletosDatasetvalor_novo';
    BoletosDatasetvalor_novo.FieldName := 'valor_novo';
    BoletosDatasetvalor_novo.Required := False;
    BoletosDatasetdata_vencimento_nova.SetParentComponent(BoletosDataset);
    BoletosDatasetdata_vencimento_nova.Name := 'BoletosDatasetdata_vencimento_nova';
    BoletosDatasetdata_vencimento_nova.FieldName := 'data_vencimento_nova';
    BoletosDatasetdata_vencimento_nova.Required := False;
    BoletosDatasettipo_liquidacao_antecipada.SetParentComponent(BoletosDataset);
    BoletosDatasettipo_liquidacao_antecipada.Name := 'BoletosDatasettipo_liquidacao_antecipada';
    BoletosDatasettipo_liquidacao_antecipada.FieldName := 'tipo_liquidacao_antecipada';
    BoletosDatasettipo_liquidacao_antecipada.Required := False;
    BoletosDatasetid_boleto_digital.SetParentComponent(BoletosDataset);
    BoletosDatasetid_boleto_digital.Name := 'BoletosDatasetid_boleto_digital';
    BoletosDatasetid_boleto_digital.FieldName := 'id_boleto_digital';
    BoletosDatasetid_boleto_digital.Required := False;
    BoletosDatasetid_boleto_digital.Size := 255;
    BoletosDatasetboleto_digital.SetParentComponent(BoletosDataset);
    BoletosDatasetboleto_digital.Name := 'BoletosDatasetboleto_digital';
    BoletosDatasetboleto_digital.FieldName := 'boleto_digital';
    BoletosDatasetboleto_digital.Required := True;
    BoletosDatasetid_externo.SetParentComponent(BoletosDataset);
    BoletosDatasetid_externo.Name := 'BoletosDatasetid_externo';
    BoletosDatasetid_externo.FieldName := 'id_externo';
    BoletosDatasetid_externo.Required := False;
    BoletosDatasetid_externo.Size := 255;
    BoletosDatasetnumero_titulo_cliente.SetParentComponent(BoletosDataset);
    BoletosDatasetnumero_titulo_cliente.Name := 'BoletosDatasetnumero_titulo_cliente';
    BoletosDatasetnumero_titulo_cliente.FieldName := 'numero_titulo_cliente';
    BoletosDatasetnumero_titulo_cliente.Required := False;
    BoletosDatasetnumero_titulo_cliente.Size := 255;
    BoletosDataseturl_boleto.SetParentComponent(BoletosDataset);
    BoletosDataseturl_boleto.Name := 'BoletosDataseturl_boleto';
    BoletosDataseturl_boleto.FieldName := 'url_boleto';
    BoletosDataseturl_boleto.Required := False;
    BoletosDataseturl_boleto.Size := 255;
    BoletosDatasetcodigo_interno.SetParentComponent(BoletosDataset);
    BoletosDatasetcodigo_interno.Name := 'BoletosDatasetcodigo_interno';
    BoletosDatasetcodigo_interno.FieldName := 'codigo_interno';
    BoletosDatasetcodigo_interno.Required := True;
    BoletosDatasetexcluido.SetParentComponent(BoletosDataset);
    BoletosDatasetexcluido.Name := 'BoletosDatasetexcluido';
    BoletosDatasetexcluido.FieldName := 'excluido';
    BoletosDatasetexcluido.Required := False;
    BoletosDatasetinclusao.SetParentComponent(BoletosDataset);
    BoletosDatasetinclusao.Name := 'BoletosDatasetinclusao';
    BoletosDatasetinclusao.FieldName := 'inclusao';
    BoletosDatasetinclusao.Required := False;
    BoletosDatasetalteracao.SetParentComponent(BoletosDataset);
    BoletosDatasetalteracao.Name := 'BoletosDatasetalteracao';
    BoletosDatasetalteracao.FieldName := 'alteracao';
    BoletosDatasetalteracao.Required := False;
    BoletosDatasetexclusao.SetParentComponent(BoletosDataset);
    BoletosDatasetexclusao.Name := 'BoletosDatasetexclusao';
    BoletosDatasetexclusao.FieldName := 'exclusao';
    BoletosDatasetexclusao.Required := False;
    XDataClientBoletosGet.SetParentComponent(Self);
    XDataClientBoletosGet.Name := 'XDataClientBoletosGet';
    XDataClientBoletosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientBoletosGet, Self, 'OnLoad', 'XDataClientBoletosGetLoad');
    XDataClientBoletosGet.Left := 64;
    XDataClientBoletosGet.Top := 8;
    XDataClientBoletosDelete.SetParentComponent(Self);
    XDataClientBoletosDelete.Name := 'XDataClientBoletosDelete';
    XDataClientBoletosDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientBoletosDelete, Self, 'OnLoad', 'XDataClientBoletosDeleteLoad');
    SetEvent(XDataClientBoletosDelete, Self, 'OnError', 'XDataClientBoletosDeleteError');
    XDataClientBoletosDelete.Left := 64;
    XDataClientBoletosDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbcliente_id.AfterLoadDFMValues;
    edcliente_id.AfterLoadDFMValues;
    lbconta_id.AfterLoadDFMValues;
    edconta_id.AfterLoadDFMValues;
    lbfuncionario_id.AfterLoadDFMValues;
    edfuncionario_id.AfterLoadDFMValues;
    lbstatus_titulo_id.AfterLoadDFMValues;
    edstatus_titulo_id.AfterLoadDFMValues;
    lbvalor.AfterLoadDFMValues;
    edvalor.AfterLoadDFMValues;
    lbdata_vencimento.AfterLoadDFMValues;
    eddata_vencimento.AfterLoadDFMValues;
    lbdata_processamento.AfterLoadDFMValues;
    eddata_processamento.AfterLoadDFMValues;
    lbnosso_numero.AfterLoadDFMValues;
    ednosso_numero.AfterLoadDFMValues;
    lbnosso_numero_dv.AfterLoadDFMValues;
    ednosso_numero_dv.AfterLoadDFMValues;
    lblinha_digitavel.AfterLoadDFMValues;
    edlinha_digitavel.AfterLoadDFMValues;
    lbcodigo_barras.AfterLoadDFMValues;
    edcodigo_barras.AfterLoadDFMValues;
    lbbanco_carteira_id.AfterLoadDFMValues;
    edbanco_carteira_id.AfterLoadDFMValues;
    lbdocumento.AfterLoadDFMValues;
    eddocumento.AfterLoadDFMValues;
    lbmensagem1.AfterLoadDFMValues;
    edmensagem1.AfterLoadDFMValues;
    lbmensagem2.AfterLoadDFMValues;
    edmensagem2.AfterLoadDFMValues;
    lbmensagem3.AfterLoadDFMValues;
    edmensagem3.AfterLoadDFMValues;
    lbtaxa_juros.AfterLoadDFMValues;
    edtaxa_juros.AfterLoadDFMValues;
    lbtaxa_multa.AfterLoadDFMValues;
    edtaxa_multa.AfterLoadDFMValues;
    lbarquivo_retorno.AfterLoadDFMValues;
    edarquivo_retorno.AfterLoadDFMValues;
    lbdata_retorno.AfterLoadDFMValues;
    eddata_retorno.AfterLoadDFMValues;
    lbdata_emissao.AfterLoadDFMValues;
    eddata_emissao.AfterLoadDFMValues;
    lbcodigo_carteira.AfterLoadDFMValues;
    edcodigo_carteira.AfterLoadDFMValues;
    lbparcela.AfterLoadDFMValues;
    edparcela.AfterLoadDFMValues;
    lbdata_pagamento.AfterLoadDFMValues;
    eddata_pagamento.AfterLoadDFMValues;
    lbvalor_pago.AfterLoadDFMValues;
    edvalor_pago.AfterLoadDFMValues;
    lbvalor_novo.AfterLoadDFMValues;
    edvalor_novo.AfterLoadDFMValues;
    lbdata_vencimento_nova.AfterLoadDFMValues;
    eddata_vencimento_nova.AfterLoadDFMValues;
    lbtipo_liquidacao_antecipada.AfterLoadDFMValues;
    edtipo_liquidacao_antecipada.AfterLoadDFMValues;
    lbid_boleto_digital.AfterLoadDFMValues;
    edid_boleto_digital.AfterLoadDFMValues;
    lbboleto_digital.AfterLoadDFMValues;
    edboleto_digital.AfterLoadDFMValues;
    lbid_externo.AfterLoadDFMValues;
    edid_externo.AfterLoadDFMValues;
    lbnumero_titulo_cliente.AfterLoadDFMValues;
    ednumero_titulo_cliente.AfterLoadDFMValues;
    lburl_boleto.AfterLoadDFMValues;
    edurl_boleto.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    BoletosDataset.AfterLoadDFMValues;
    BoletosDatasetid.AfterLoadDFMValues;
    BoletosDatasetaliado_id.AfterLoadDFMValues;
    BoletosDatasetdata_base_id.AfterLoadDFMValues;
    BoletosDatasetcliente_id.AfterLoadDFMValues;
    BoletosDatasetconta_id.AfterLoadDFMValues;
    BoletosDatasetfuncionario_id.AfterLoadDFMValues;
    BoletosDatasetstatus_titulo_id.AfterLoadDFMValues;
    BoletosDatasetvalor.AfterLoadDFMValues;
    BoletosDatasetdata_vencimento.AfterLoadDFMValues;
    BoletosDatasetdata_processamento.AfterLoadDFMValues;
    BoletosDatasetnosso_numero.AfterLoadDFMValues;
    BoletosDatasetnosso_numero_dv.AfterLoadDFMValues;
    BoletosDatasetlinha_digitavel.AfterLoadDFMValues;
    BoletosDatasetcodigo_barras.AfterLoadDFMValues;
    BoletosDatasetbanco_carteira_id.AfterLoadDFMValues;
    BoletosDatasetdocumento.AfterLoadDFMValues;
    BoletosDatasetmensagem1.AfterLoadDFMValues;
    BoletosDatasetmensagem2.AfterLoadDFMValues;
    BoletosDatasetmensagem3.AfterLoadDFMValues;
    BoletosDatasettaxa_juros.AfterLoadDFMValues;
    BoletosDatasettaxa_multa.AfterLoadDFMValues;
    BoletosDatasetarquivo_retorno.AfterLoadDFMValues;
    BoletosDatasetdata_retorno.AfterLoadDFMValues;
    BoletosDatasetdata_emissao.AfterLoadDFMValues;
    BoletosDatasetcodigo_carteira.AfterLoadDFMValues;
    BoletosDatasetparcela.AfterLoadDFMValues;
    BoletosDatasetdata_pagamento.AfterLoadDFMValues;
    BoletosDatasetvalor_pago.AfterLoadDFMValues;
    BoletosDatasetvalor_novo.AfterLoadDFMValues;
    BoletosDatasetdata_vencimento_nova.AfterLoadDFMValues;
    BoletosDatasettipo_liquidacao_antecipada.AfterLoadDFMValues;
    BoletosDatasetid_boleto_digital.AfterLoadDFMValues;
    BoletosDatasetboleto_digital.AfterLoadDFMValues;
    BoletosDatasetid_externo.AfterLoadDFMValues;
    BoletosDatasetnumero_titulo_cliente.AfterLoadDFMValues;
    BoletosDataseturl_boleto.AfterLoadDFMValues;
    BoletosDatasetcodigo_interno.AfterLoadDFMValues;
    BoletosDatasetexcluido.AfterLoadDFMValues;
    BoletosDatasetinclusao.AfterLoadDFMValues;
    BoletosDatasetalteracao.AfterLoadDFMValues;
    BoletosDatasetexclusao.AfterLoadDFMValues;
    XDataClientBoletosGet.AfterLoadDFMValues;
    XDataClientBoletosDelete.AfterLoadDFMValues;
  end;
end;

end.
